<template>
  <table
  :style="cssVars"
  :class="style.borders ? 'bordered' : ''"
  class="styled-table">
    <template >
      <tr class="border-top">
        <td class="categ-title extra-pad">
          Patologia Oncológica
        </td>
        <td colspan="2" class="categ-title" style="text-align: center !important;" >
          Causistica
        </td>
      </tr>
        <tr v-for="(log, index) in tableValues" :key="index">
          <td class="subcateg-title pl-4">
            <span>{{log.name}}</span>
          </td>
          <td>{{log.inpatientCount}}</td>
          <td>{{Math.round(log.inpatientPercent)}}%</td>
        </tr>
    </template>
    <tr>
      <td>Total</td>
      <td>{{inpatientTotal}}</td>
      <td>100%</td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    logs: { type: Array },
  },
  data() {
    return {
      inpatientTotal: 0,
      style: {
        borders: true,
        borderColor: '#cccccc',
        colors: ['#ffffff']
      },
    }
  },
  computed: {
    cssVars() {
      return {
        '--bg-color': this.style.colors[0],
        '--bg-light-color': this.style.colors[0] + 20,
        '--categ-color': this.style.colors[0] + 99,
        '--subcateg-color': this.style.colors[0] + 60,
        '--border-collapse': this.style.borders ? 'collapse' : 'inherit',
        '--border-color': this.style.borderColor,
        '--accent-border-color': this.style.borderColor + 50
      }
    },
    labeledLogs() {
      return this.$store.getters.labeledLogs
    },
    tableValues() {
      let count = {}
      this.labeledLogs.map(log => {
        if(log['urgent-clinical-situation'] && log.logbook === 'non-programmed-appointment') {
          const id = log['urgent-clinical-situation'].id
          if(!count[id]) {
            const inpatientCount = 1
            count[id] = {
                name: log['urgent-clinical-situation'].text,
                inpatientCount: parseInt(inpatientCount),
              }
          } else if (count[id]) {
            count[id].inpatientCount++
           }
        } 
      })
      Object.keys(count).map(item => {
        this.inpatientTotal = this.inpatientTotal + count[item].inpatientCount
      })
      Object.keys(count).map(item => {
        count[item].inpatientPercent = (count[item].inpatientCount / this.inpatientTotal) * 100
      })
      return count
    }
  },
  mounted() {
    this.$root.$emit('isTable', true)
    this.$root.$on('selectedStyle', style => {
      this.style = style
    })
  },
}
</script>

<style>

</style>